module.exports = __webpack_public_path__ + "img/GS_Profile-Itumeleng Thoka.287d7865.png";